type ManagePlanUsageBarProps = {
  used: number;
  total: number;
};

export function ManagePlanUsageBar({ used, total }: ManagePlanUsageBarProps) {
  const percentage = total > 0 ? Math.min((used / total) * 100, 100) : 0;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span className="shrink-0 text-xs leading-4 text-[#6c7689]">
          Current Usage
        </span>
        <span className="h-0 flex-1 border-b border-dashed border-[#e8eaed]" />
        <span className="shrink-0 text-xs leading-4 text-[#1f2633]">
          {Math.round(used).toLocaleString()} /{" "}
          {Math.round(total).toLocaleString()}
        </span>
      </div>
      <div className="h-[5px] w-full overflow-hidden rounded-[32px] bg-[#f3f4f6]">
        <div
          className="h-[5px] rounded-[32px] bg-[#0099ff] transition-all"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
